import React, { useEffect, useState } from "react";
import Input from "components/Form/Input";
import Button from "components/Button/Button";
import InputFile from "components/Form/InputFile";
import makeToast from "utils/toast/makeToast";
import useAuth from "hooks/useAuth";
import { useNavigate } from "react-router-dom";
import actionApi from "services/actionApi";

const RegisterPageStepTwo = ({
  register,
  setValue,
  handleSubmit,
  errors,
  isDirty,
  isValid,
  watchStep1,
}) => {
  const { doLogin } = useAuth();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const disabled =
    isSubmitting || !isDirty || !isValid || Object.keys(errors).length > 0;
  const email = watchStep1("email");

  const onSubmitRegister = async (payload) => {
    if (Object.keys(errors).length > 0) {
      makeToast({
        label: "One or more fields have an error. Please check and try again",
        type: "error",
      });
    }

    const body = {
      ...payload,
      email: watchStep1("email"),
      name: watchStep1("name"),
      phone: watchStep1("phone"),
      password: watchStep1("password"),
    };

    setIsSubmitting(true);
    await actionApi
      .register(body)
      .then((response) => {
        doLogin(response?.data?.access);
        navigate("/");
      })
      .catch((err) => {
        makeToast({ label: err?.response?.data?.errors?.[0], type: "error" });
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <form className="flex flex-col" onSubmit={handleSubmit(onSubmitRegister)}>
      <Input
        {...register("linkedin_url", { required: true })}
        className="mb-4"
        placeholder="URL LinkedIn Account"
        errors={errors}
      />
      <Input
        {...register("education", { required: true })}
        className="mb-4"
        placeholder="Education (ex: S1)"
        errors={errors}
      />
      <Input
        {...register("institution", { required: true })}
        className="mb-4"
        placeholder="Institution (ex: Universitas Indonesia)"
        errors={errors}
      />
      <InputFile
        {...register("cv_file_id", { required: true })}
        errors={errors}
        setValue={setValue}
        placeholder={"Upload your CV (.pdf)"}
        type="cv"
        email={email}
      />
      <Button
        type="submit"
        size="large"
        className="w-full mb-6 h-10 mt-4"
        rounded
        disabled={disabled}
      >
        Register
      </Button>
    </form>
  );
};

export default RegisterPageStepTwo;
